import { render, staticRenderFns } from "./AppCollapse.vue?vue&type=template&id=da798080&"
import script from "./AppCollapse.vue?vue&type=script&lang=js&"
export * from "./AppCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports